// extracted by mini-css-extract-plugin
export default {"AllProjects":"Projects_AllProjects__Ekqk4","SingleProject":"Projects_SingleProject__pRadg"};